export default __webpack_public_path__ + "static/media/primitive-mine.78771202.svg";